import React from 'react';
import glamorous from 'glamorous';

const ContentContainer = glamorous.div(
  {
    boxSizing: 'border-box',
    transition: 'max-height 0.4s linear',
    maxHeight: '500px',
  },
  ({ collapsed }) => {
    return (
      collapsed && {
        transitionDuration: '0.3s',
        transitionTimingFunction: 'ease-out',
        maxHeight: '0px',
        overflow: 'hidden',
      }
    );
  }
);

const AccordionContent = ({ children, collapsed, ...restProps }) => {
  return (
    <ContentContainer {...restProps} collapsed={collapsed}>
      {children}
    </ContentContainer>
  );
};

export default AccordionContent;



// WEBPACK FOOTER //
// ./src/App/account/components/Accordion/DefaultComponents/Content.js